module.exports = __webpack_public_path__ + "prod/1.42.2/img/cpjs_two.a2e3d4cc.png";